module.exports = __webpack_public_path__ + "static/media/empty.6d742562.png";